var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#020633",
    stroke: "#020633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6,8.4h-1.1c-0.8,0-1.4-0.6-1.4-1.4V4.9c0-0.8,0.6-1.4,1.4-1.4h1.1c0.8,0,1.4,0.6,1.4,1.4V7 C14,7.7,13.3,8.4,12.6,8.4z",
    fill: "white",
    stroke: "#020633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,10.3l-0.3,1.1c-0.2,0.7-1,1.1-1.7,0.9l-2-0.7c-0.7-0.2-1.1-1-0.9-1.7l0.3-1.1c0.2-0.7,1-1.1,1.7-0.9 l2,0.7C8.6,8.8,9,9.6,8.7,10.3z",
    fill: "white",
    stroke: "#020633"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4,14.6l0.9,0.7c0.6,0.5,0.7,1.3,0.3,1.9l-1.2,1.7c-0.5,0.6-1.3,0.7-1.9,0.3l-0.9-0.7 c-0.6-0.5-0.7-1.3-0.3-1.9l1.2-1.7C7.9,14.3,8.8,14.2,9.4,14.6z",
    fill: "white",
    stroke: "#020633"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7,15.3l0.9-0.7c0.6-0.5,1.5-0.3,1.9,0.3l1.2,1.7c0.5,0.6,0.3,1.5-0.3,1.9l-0.9,0.7 c-0.6,0.5-1.5,0.3-1.9-0.3l-1.2-1.7C12.9,16.6,13,15.7,13.7,15.3z",
    fill: "white",
    stroke: "#020633"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6,11.4l-0.3-1.1c-0.2-0.7,0.2-1.5,0.9-1.7l2-0.7c0.7-0.2,1.5,0.2,1.7,0.9l0.3,1.1c0.2,0.7-0.2,1.5-0.9,1.7 l-2,0.7C16.7,12.6,15.9,12.2,15.6,11.4z",
    fill: "white",
    stroke: "#020633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDock);
export default __webpack_public_path__ + "static/media/dock.8966999f.svg";
export { ForwardRef as ReactComponent };